module.exports = __webpack_public_path__ + "img/Logo_GOES_horizontal_L.94568883.svg";